import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  Input,
  OnInit,
  signal,
  ViewEncapsulation
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { RolloutPlanStore } from '../../../+state/rollout/rollout-plan-form.store';
import { useRolloutPlanStore } from '../../../+state/rollout/rollout-plan.store';

import { PlanDetailsService } from './plan-details.service';

@Component({
  selector: 'remote-update-domain-app-plan-details',
  templateUrl: './plan-details.html',
  styleUrls: ['./plan-details.scss'],
  imports: [MatFormFieldModule, MatSelectModule, CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None
})
export class PlanDetails implements OnInit {
  @Input() currentSection = '';
  selected = signal({
    id: 0,
    version: ''
  });

  private store = inject(useRolloutPlanStore);
  private rolloutPlanGlobalStore = inject(RolloutPlanStore);
  private planDetailsService = inject(PlanDetailsService);
  isEditingRolloutPlan = computed(() => this.rolloutPlanGlobalStore.isEditingRolloutPlan());

  eligiblePackages = computed(() => this.store.allRolloutPlanEligiblePackages().data ?? []);
  selectedVersion = signal('');
  ngOnInit(): void {
    const planDetails = this.rolloutPlanGlobalStore.planDetails();
    if (planDetails.firmware_package_bundle_version.trim() !== '' && this.isEditingRolloutPlan()) {
      this.selectedVersion.set(planDetails.firmware_package_bundle_version);

      this.rolloutPlanGlobalStore.updatePlanDetails(
        {
          firmwarePackageId: Number(planDetails.firmwarePackageId),
          firmware_package_bundle_version: planDetails.firmware_package_bundle_version,
          isValid: true
        },
        ''
      );
    }
  }

  constructor() {
    this.fetchEligiblePackages();

    effect(() => {
      if (this.selected().version.length > 0) {
        this.rolloutPlanGlobalStore.updatePlanDetails(
          {
            firmwarePackageId: Number(this.selected().id),
            firmware_package_bundle_version: this.selected().version,
            isValid: true
          },
          ''
        );
      }
    });
  }

  async fetchEligiblePackages() {
    await this.planDetailsService.loadAllRolloutPlanEligiblePackages();
  }

  get error(): string | undefined {
    return this.rolloutPlanGlobalStore.errors().planDetails;
  }
}
